import { FaBars } from "react-icons/fa";
import { RadixConnectWithContext } from "../../../radix_connect";
import logoImage from "../SlapGenerator/images/piersslap.png";
import CustomSelectRadixAccount from "./CustomSelectRadixAccount";
// Styling handled by Tailwind in globals.css (imported in Layout.js)

const TopBar = ({ toggleSidebar }) => {
  return (
    <header className="top-bar">
      <div className="top-bar-left">
        <button className="hamburger-menu" onClick={toggleSidebar}>
          <FaBars />
        </button>
        <img src={logoImage} alt="DCKSLAP" className="logo-image" />
      </div>
      <div className="wallet-connector">
        <div className="custom-select-wrapper">
          <CustomSelectRadixAccount />
        </div>
        <RadixConnectWithContext />
      </div>
    </header>
  );
};

export default TopBar;
